import * as React from "react";

export default (refetch = () => {}) => {
  React.useEffect(() => {
    const onfocus = () => {
      if (document.visibilityState === "visible") {
        refetch();
      }
    };

    document.addEventListener("visibilitychange", onfocus);

    return () => document.removeEventListener("visibilitychange", onfocus);
  }, [refetch]);

  React.useEffect(() => {
    refetch();
  }, [refetch]);
};
